var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateKnowledgeLessonsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8881 37.7584L45.1875 33.9795L43.487 37.7584L39.7081 39.4589L43.487 41.1595L45.1875 44.9384L46.8881 41.1595L50.667 39.4589L46.8881 37.7584Z",
    fill: "#232B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53161 43.2399L6.83109 39.4609L5.13058 43.2399L1.35164 44.9404L5.13057 46.6409L6.83109 50.4198L8.53161 46.6409L12.3105 44.9404L8.53161 43.2399Z",
    fill: "#232B35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4368 6.08832L8.88605 0.419922L6.33527 6.08832L0.66687 8.6391L6.33527 11.1899L8.88605 16.8583L11.4368 11.1899L17.1052 8.6391L11.4368 6.08832Z",
    fill: "#232B35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5308,
    y: 52.4707,
    width: 10.9589,
    height: 4.10959,
    rx: 2.05479,
    stroke: "#232B35",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.791,
    y: 48.3623,
    width: 16.4384,
    height: 4.10959,
    rx: 2.05479,
    stroke: "#232B35",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5306 48.3628V44.2532C20.5306 40.4135 17.5409 37.0859 17.1483 36.6654C17.1197 36.6348 17.0906 36.6064 17.0602 36.5776C14.5574 34.2058 12.9963 30.8502 12.9963 27.1299C12.9963 19.9426 18.8228 14.1162 26.01 14.1162C33.1973 14.1162 39.0237 19.9426 39.0237 27.1299C39.0237 30.8398 37.4714 34.1871 34.9808 36.5577C34.9365 36.5998 34.895 36.6402 34.8535 36.6851C34.3948 37.1805 31.4895 40.468 31.4895 44.2532V48.3628",
    stroke: "#232B35",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4254 47.2828C24.3221 46.4674 25.1244 33.7312 20.5308 30.1709",
    stroke: "#232B35",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3847 47.2828C27.488 46.4674 26.6856 33.7312 31.2793 30.1709",
    stroke: "#232B35",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateKnowledgeLessonsImage);
export default __webpack_public_path__ + "static/media/CreateKnowledgeLessonsImage.a45992fdf7474b0ee6ad7c8d71a29d5b.svg";
export { ForwardRef as ReactComponent };